import { TriangleAlert } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'

const COPY = 'identity.detail.audio.shortEvidence'

/** Short recording excerpts remain reviewable, with their limited evidence made explicit. */
export function ShortVoiceEvidence({ detail = false }: { detail?: boolean }) {
  const { t } = useTranslation()
  return (
    <span className="inline-flex flex-col items-start gap-1.5">
      <Badge variant="warning">
        <TriangleAlert aria-hidden />
        {t(`${COPY}.label`)}
      </Badge>
      {detail && <span className="text-xs text-muted-foreground">{t(`${COPY}.detail`)}</span>}
    </span>
  )
}
